var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 32,
    viewBox: "0 0 2560.000000 693.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,693.000000) scale(0.100000,-0.100000)",
    fill: "#71778A",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3470 c0 -1903 3 -3460 7 -3460 3 0 128 18 277 40 320 46 533 75 671 90 55 6 110 13 122 15 l23 5 2 1885 3 1884 617 -1807 c527 -1545 619 -1807 635 -1805 10 1 126 13 258 27 132 15 323 35 425 46 102 11 251 30 333 42 l147 21 0 3239 0 3238 -545 0 -545 0 -2 -1957 -3 -1957 -700 1957 -700 1957 -512 0 -513 0 0 -3460z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4570 3735 l0 -3195 43 5 c23 3 157 14 297 25 140 11 426 33 635 50 209 16 724 57 1145 90 421 33 789 62 818 66 l52 5 0 518 0 518 -97 -4 c-392 -17 -1554 -88 -1755 -108 l-58 -6 0 805 c0 602 3 807 12 812 6 4 306 9 667 11 361 2 680 6 709 9 l52 5 0 536 0 536 -492 -7 c-271 -3 -595 -9 -720 -13 l-228 -6 0 732 0 731 955 0 955 0 0 540 0 540 -1495 0 -1495 0 0 -3195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8260 6390 l0 -540 560 0 560 0 0 -2497 0 -2496 122 6 c66 4 309 7 540 7 l418 0 0 2490 0 2490 560 0 560 0 0 540 0 540 -1660 0 -1660 0 0 -540z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12280 3930 l0 -3000 528 2 527 3 3 1227 2 1228 735 0 735 0 0 540 0 540 -735 0 -735 0 0 690 0 690 975 0 975 0 0 540 0 540 -1505 0 -1505 0 0 -3000z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15970 3895 l0 -3035 48 0 c312 -1 1451 -54 2366 -110 263 -17 484 -30 492 -30 12 0 14 84 14 529 l0 530 -42 5 c-24 3 -167 13 -318 21 -151 9 -378 22 -505 30 -126 8 -356 19 -510 25 -154 6 -322 13 -372 16 l-93 6 0 2524 0 2524 -540 0 -540 0 0 -3035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19802 3788 l3 -3143 325 -21 c339 -23 682 -51 713 -60 16 -5 17 151 17 3180 l0 3186 -530 0 -530 0 2 -3142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21799 6908 c5 -13 288 -745 629 -1627 l620 -1603 -694 -1581 c-381 -869 -691 -1583 -689 -1585 7 -8 84 -17 455 -57 184 -20 415 -47 513 -61 98 -14 180 -24 182 -22 2 2 151 346 331 763 179 418 356 829 392 913 36 84 69 149 72 145 4 -5 179 -451 389 -993 210 -542 385 -988 389 -992 16 -14 1190 -203 1201 -193 2 3 -303 818 -678 1811 -376 994 -681 1814 -678 1823 5 17 1356 3261 1364 3274 2 4 -262 6 -588 5 l-592 -3 -375 -902 c-206 -497 -378 -903 -381 -903 -3 0 -164 406 -358 903 l-351 902 -581 3 -581 2 9 -22z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/Netflix.23f8e7e9054ef2e1fe081a7f461144d6.svg";
export { ForwardRef as ReactComponent };